export const CountryCodes = [
  {
    name: 'Afghanistan',
    dial_code: '+93',
    code: 'AF',
    lang_iso_code: 'fa',
    language: 'Persian',
  },
  {
    name: 'Aland Islands',
    dial_code: '+358',
    code: 'AX',
    lang_iso_code: 'sv',
    language: 'Swedish',
  },
  {
    name: 'Albania',
    dial_code: '+355',
    code: 'AL',
    lang_iso_code: 'sq',
    language: 'Albanian',
  },
  {
    name: 'Algeria',
    dial_code: '+213',
    code: 'DZ',
    lang_iso_code: 'ar',
    language: 'Arabic',
  },
  {
    name: 'American Samoa',
    dial_code: '+1684',
    code: 'AS',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Andorra',
    dial_code: '+376',
    code: 'AD',
    lang_iso_code: 'ca',
    language: 'Catalan',
  },
  {
    name: 'Angola',
    dial_code: '+244',
    code: 'AO',
    lang_iso_code: 'pt',
    language: 'Portuguese',
  },
  {
    name: 'Anguilla',
    dial_code: '+1264',
    code: 'AI',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Antarctica',
    dial_code: '+672',
    code: 'AQ',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Antigua and Barbuda',
    dial_code: '+1268',
    code: 'AG',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Argentina',
    dial_code: '+54',
    code: 'AR',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: 'Armenia',
    dial_code: '+374',
    code: 'AM',
    lang_iso_code: 'hy',
    language: 'Armenian',
  },
  {
    name: 'Aruba',
    dial_code: '+297',
    code: 'AW',
    lang_iso_code: 'nl',
    language: 'Dutch',
  },
  {
    name: 'Australia',
    dial_code: '+61',
    code: 'AU',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Austria',
    dial_code: '+43',
    code: 'AT',
    lang_iso_code: 'de',
    language: 'German',
  },
  {
    name: 'Azerbaijan',
    dial_code: '+994',
    code: 'AZ',
    lang_iso_code: 'az',
    language: 'Azerbaijani',
  },
  {
    name: 'Bahamas',
    dial_code: '+1242',
    code: 'BS',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Bahrain',
    dial_code: '+973',
    code: 'BH',
    lang_iso_code: 'ar',
    language: 'Arabic',
  },
  {
    name: 'Bangladesh',
    dial_code: '+880',
    code: 'BD',
    lang_iso_code: 'bn',
    language: 'Bengali',
  },
  {
    name: 'Barbados',
    dial_code: '+1246',
    code: 'BB',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Belarus',
    dial_code: '+375',
    code: 'BY',
    lang_iso_code: 'be',
    language: 'Belarusian',
  },
  {
    name: 'Belgium',
    dial_code: '+32',
    code: 'BE',
    lang_iso_code: 'nl',
    language: 'Dutch',
  },
  {
    name: 'Belize',
    dial_code: '+501',
    code: 'BZ',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Benin',
    dial_code: '+229',
    code: 'BJ',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Bermuda',
    dial_code: '+1441',
    code: 'BM',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Bhutan',
    dial_code: '+975',
    code: 'BT',
    lang_iso_code: 'dz',
    language: 'Dzongkha',
  },
  {
    name: 'Bolivia, Plurinational State of',
    dial_code: '+591',
    code: 'BO',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: 'Bosnia and Herzegovina',
    dial_code: '+387',
    code: 'BA',
    lang_iso_code: 'bs',
    language: 'Bosnian',
  },
  {
    name: 'Botswana',
    dial_code: '+267',
    code: 'BW',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Brazil',
    dial_code: '+55',
    code: 'BR',
    lang_iso_code: 'pt',
    language: 'Portuguese',
  },
  {
    name: 'British Indian Ocean Territory',
    dial_code: '+246',
    code: 'IO',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Brunei Darussalam',
    dial_code: '+673',
    code: 'BN',
    lang_iso_code: 'ms',
    language: 'Malay',
  },
  {
    name: 'Bulgaria',
    dial_code: '+359',
    code: 'BG',
    lang_iso_code: 'bg',
    language: 'Bulgarian',
  },
  {
    name: 'Burkina Faso',
    dial_code: '+226',
    code: 'BF',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Burundi',
    dial_code: '+257',
    code: 'BI',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Cambodia',
    dial_code: '+855',
    code: 'KH',
    lang_iso_code: 'km',
    language: 'Khmer',
  },
  {
    name: 'Cameroon',
    dial_code: '+237',
    code: 'CM',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Canada',
    dial_code: '+1',
    code: 'CA',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Cape Verde',
    dial_code: '+238',
    code: 'CV',
    lang_iso_code: 'pt',
    language: 'Portuguese',
  },
  {
    name: 'Cayman Islands',
    dial_code: '+345',
    code: 'KY',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Central African Republic',
    dial_code: '+236',
    code: 'CF',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Chad',
    dial_code: '+235',
    code: 'TD',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Chile',
    dial_code: '+56',
    code: 'CL',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: 'China',
    dial_code: '+86',
    code: 'CN',
    lang_iso_code: 'zh',
    language: 'Chinese',
  },
  {
    name: 'Christmas Island',
    dial_code: '+61',
    code: 'CX',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Cocos (Keeling) Islands',
    dial_code: '+61',
    code: 'CC',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Colombia',
    dial_code: '+57',
    code: 'CO',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: 'Comoros',
    dial_code: '+269',
    code: 'KM',
    lang_iso_code: 'ar',
    language: 'Arabic',
  },
  {
    name: 'Congo',
    dial_code: '+242',
    code: 'CG',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Congo, The Democratic Republic of the',
    dial_code: '+243',
    code: 'CD',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Cook Islands',
    dial_code: '+682',
    code: 'CK',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Costa Rica',
    dial_code: '+506',
    code: 'CR',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: "Cote d'Ivoire",
    dial_code: '+225',
    code: 'CI',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Croatia',
    dial_code: '+385',
    code: 'HR',
    lang_iso_code: 'hr',
    language: 'Croatian',
  },
  {
    name: 'Cuba',
    dial_code: '+53',
    code: 'CU',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: 'Cyprus',
    dial_code: '+357',
    code: 'CY',
    lang_iso_code: 'el',
    language: 'Greek',
  },
  {
    name: 'Czech Republic',
    dial_code: '+420',
    code: 'CZ',
    lang_iso_code: 'cs',
    language: 'Czech',
  },
  {
    name: 'Denmark',
    dial_code: '+45',
    code: 'DK',
    lang_iso_code: 'da',
    language: 'Danish',
  },
  {
    name: 'Djibouti',
    dial_code: '+253',
    code: 'DJ',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Dominica',
    dial_code: '+1767',
    code: 'DM',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Dominican Republic',
    dial_code: '+1849',
    code: 'DO',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: 'Ecuador',
    dial_code: '+593',
    code: 'EC',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: 'Egypt',
    dial_code: '+20',
    code: 'EG',
    lang_iso_code: 'ar',
    language: 'Arabic',
  },
  {
    name: 'El Salvador',
    dial_code: '+503',
    code: 'SV',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: 'Equatorial Guinea',
    dial_code: '+240',
    code: 'GQ',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: 'Eritrea',
    dial_code: '+291',
    code: 'ER',
    lang_iso_code: 'ti',
    language: 'Tigrinya',
  },
  {
    name: 'Estonia',
    dial_code: '+372',
    code: 'EE',
    lang_iso_code: 'et',
    language: 'Estonian',
  },
  {
    name: 'Ethiopia',
    dial_code: '+251',
    code: 'ET',
    lang_iso_code: 'am',
    language: 'Amharic',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    dial_code: '+500',
    code: 'FK',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Faroe Islands',
    dial_code: '+298',
    code: 'FO',
    lang_iso_code: 'fo',
    language: 'Faroese',
  },
  {
    name: 'Fiji',
    dial_code: '+679',
    code: 'FJ',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Finland',
    dial_code: '+358',
    code: 'FI',
    lang_iso_code: 'fi',
    language: 'Finnish',
  },
  {
    name: 'France',
    dial_code: '+33',
    code: 'FR',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'French Guiana',
    dial_code: '+594',
    code: 'GF',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'French Polynesia',
    dial_code: '+689',
    code: 'PF',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'French Southern Territories',
    dial_code: '+262',
    code: 'TF',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Gabon',
    dial_code: '+241',
    code: 'GA',
    lang_iso_code: 'fr',
    language: 'French',
  },

  {
    name: 'Gambia',
    dial_code: '+220',
    code: 'GM',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Georgia',
    dial_code: '+995',
    code: 'GE',
    lang_iso_code: 'ka',
    language: 'Georgian',
  },
  {
    name: 'Germany',
    dial_code: '+49',
    code: 'DE',
    lang_iso_code: 'de',
    language: 'German',
  },
  {
    name: 'Ghana',
    dial_code: '+233',
    code: 'GH',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Gibraltar',
    dial_code: '+350',
    code: 'GI',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Greece',
    dial_code: '+30',
    code: 'GR',
    lang_iso_code: 'el',
    language: 'Greek',
  },
  {
    name: 'Greenland',
    dial_code: '+299',
    code: 'GL',
    lang_iso_code: 'kl',
    language: 'Greenlandic',
  },
  {
    name: 'Grenada',
    dial_code: '+1473',
    code: 'GD',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Guadeloupe',
    dial_code: '+590',
    code: 'GP',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Guam',
    dial_code: '+1671',
    code: 'GU',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Guatemala',
    dial_code: '+502',
    code: 'GT',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: 'Guinea',
    dial_code: '+224',
    code: 'GN',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Guinea-Bissau',
    dial_code: '+245',
    code: 'GW',
    lang_iso_code: 'pt',
    language: 'Portuguese',
  },
  {
    name: 'Guyana',
    dial_code: '+595',
    code: 'GY',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Haiti',
    dial_code: '+509',
    code: 'HT',
    lang_iso_code: 'ht',
    language: 'Haitian Creole',
  },
  {
    name: 'Holy See (Vatican City State)',
    dial_code: '+379',
    code: 'VA',
    lang_iso_code: 'la',
    language: 'Latin',
  },
  {
    name: 'Honduras',
    dial_code: '+504',
    code: 'HN',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: 'Hong Kong',
    dial_code: '+852',
    code: 'HK',
    lang_iso_code: 'zh',
    language: 'Chinese',
  },
  {
    name: 'Hungary',
    dial_code: '+36',
    code: 'HU',
    lang_iso_code: 'hu',
    language: 'Hungarian',
  },
  {
    name: 'Iceland',
    dial_code: '+354',
    code: 'IS',
    lang_iso_code: 'is',
    language: 'Icelandic',
  },
  {
    name: 'India',
    dial_code: '+91',
    code: 'IN',
    lang_iso_code: 'hi',
    language: 'Hindi',
  },
  {
    name: 'Indonesia',
    dial_code: '+62',
    code: 'ID',
    lang_iso_code: 'id',
    language: 'Indonesian',
  },
  {
    name: 'Iran',
    dial_code: '+98',
    code: 'IR',
    lang_iso_code: 'fa',
    language: 'Persian',
  },
  {
    name: 'Iraq',
    dial_code: '+964',
    code: 'IQ',
    lang_iso_code: 'ar',
    language: 'Arabic',
  },
  {
    name: 'Ireland',
    dial_code: '+353',
    code: 'IE',
    lang_iso_code: 'ga',
    language: 'Irish',
  },
  {
    name: 'Israel',
    dial_code: '+972',
    code: 'IL',
    lang_iso_code: 'he',
    language: 'Hebrew',
  },
  {
    name: 'Italy',
    dial_code: '+39',
    code: 'IT',
    lang_iso_code: 'it',
    language: 'Italian',
  },
  {
    name: 'Jamaica',
    dial_code: '+1876',
    code: 'JM',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Japan',
    dial_code: '+81',
    code: 'JP',
    lang_iso_code: 'ja',
    language: 'Japanese',
  },
  {
    name: 'Jordan',
    dial_code: '+962',
    code: 'JO',
    lang_iso_code: 'ar',
    language: 'Arabic',
  },
  {
    name: 'Kazakhstan',
    dial_code: '+77',
    code: 'KZ',
    lang_iso_code: 'kk',
    language: 'Kazakh',
  },
  {
    name: 'Kenya',
    dial_code: '+254',
    code: 'KE',
    lang_iso_code: 'sw',
    language: 'Swahili',
  },
  {
    name: 'Kiribati',
    dial_code: '+686',
    code: 'KI',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    dial_code: '+850',
    code: 'KP',
    lang_iso_code: 'ko',
    language: 'Korean',
  },
  {
    name: 'Korea, Republic of South Korea',
    dial_code: '+82',
    code: 'KR',
    lang_iso_code: 'ko',
    language: 'Korean',
  },
  {
    name: 'Kuwait',
    dial_code: '+965',
    code: 'KW',
    lang_iso_code: 'ar',
    language: 'Arabic',
  },
  {
    name: 'Kyrgyzstan',
    dial_code: '+996',
    code: 'KG',
    lang_iso_code: 'ky',
    language: 'Kyrgyz',
  },
  {
    name: 'Laos',
    dial_code: '+856',
    code: 'LA',
    lang_iso_code: 'lo',
    language: 'Lao',
  },
  {
    name: 'Latvia',
    dial_code: '+371',
    code: 'LV',
    lang_iso_code: 'lv',
    language: 'Latvian',
  },
  {
    name: 'Lebanon',
    dial_code: '+961',
    code: 'LB',
    lang_iso_code: 'ar',
    language: 'Arabic',
  },
  {
    name: 'Lesotho',
    dial_code: '+266',
    code: 'LS',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Liberia',
    dial_code: '+231',
    code: 'LR',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Libyan Arab Jamahiriya',
    dial_code: '+218',
    code: 'LY',
    lang_iso_code: 'ar',
    language: 'Arabic',
  },
  {
    name: 'Liechtenstein',
    dial_code: '+423',
    code: 'LI',
    lang_iso_code: 'de',
    language: 'German',
  },
  {
    name: 'Lithuania',
    dial_code: '+370',
    code: 'LT',
    lang_iso_code: 'lt',
    language: 'Lithuanian',
  },
  {
    name: 'Luxembourg',
    dial_code: '+352',
    code: 'LU',
    lang_iso_code: 'lb',
    language: 'Luxembourgish',
  },
  {
    name: 'Macao',
    dial_code: '+853',
    code: 'MO',
    lang_iso_code: 'zh',
    language: 'Chinese',
  },
  {
    name: 'Macedonia',
    dial_code: '+389',
    code: 'MK',
    lang_iso_code: 'mk',
    language: 'Macedonian',
  },
  {
    name: 'Madagascar',
    dial_code: '+261',
    code: 'MG',
    lang_iso_code: 'mg',
    language: 'Malagasy',
  },
  {
    name: 'Malawi',
    dial_code: '+265',
    code: 'MW',
    lang_iso_code: 'ny',
    language: 'Chichewa',
  },
  {
    name: 'Malaysia',
    dial_code: '+60',
    code: 'MY',
    lang_iso_code: 'ms',
    language: 'Malay',
  },
  {
    name: 'Maldives',
    dial_code: '+960',
    code: 'MV',
    lang_iso_code: 'dv',
    language: 'Divehi',
  },
  {
    name: 'Mali',
    dial_code: '+223',
    code: 'ML',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Malta',
    dial_code: '+356',
    code: 'MT',
    lang_iso_code: 'mt',
    language: 'Maltese',
  },
  {
    name: 'Marshall Islands',
    dial_code: '+692',
    code: 'MH',
    lang_iso_code: 'mh',
    language: 'Marshallese',
  },
  {
    name: 'Martinique',
    dial_code: '+596',
    code: 'MQ',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Mauritania',
    dial_code: '+222',
    code: 'MR',
    lang_iso_code: 'ar',
    language: 'Arabic',
  },
  {
    name: 'Mauritius',
    dial_code: '+230',
    code: 'MU',
    lang_iso_code: 'mfe',
    language: 'Mauritian Creole',
  },
  {
    name: 'Mayotte',
    dial_code: '+262',
    code: 'YT',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Mexico',
    dial_code: '+52',
    code: 'MX',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    dial_code: '+691',
    code: 'FM',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Moldova',
    dial_code: '+373',
    code: 'MD',
    lang_iso_code: 'ro',
    language: 'Romanian',
  },
  {
    name: 'Monaco',
    dial_code: '+377',
    code: 'MC',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Mongolia',
    dial_code: '+976',
    code: 'MN',
    lang_iso_code: 'mn',
    language: 'Mongolian',
  },
  {
    name: 'Montenegro',
    dial_code: '+382',
    code: 'ME',
    lang_iso_code: 'sr',
    language: 'Serbian',
  },
  {
    name: 'Montserrat',
    dial_code: '+1664',
    code: 'MS',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Morocco',
    dial_code: '+212',
    code: 'MA',
    lang_iso_code: 'ar',
    language: 'Arabic',
  },
  {
    name: 'Mozambique',
    dial_code: '+258',
    code: 'MZ',
    lang_iso_code: 'pt',
    language: 'Portuguese',
  },
  {
    name: 'Myanmar',
    dial_code: '+95',
    code: 'MM',
    lang_iso_code: 'my',
    language: 'Burmese',
  },
  {
    name: 'Namibia',
    dial_code: '+264',
    code: 'NA',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Nauru',
    dial_code: '+674',
    code: 'NR',
    lang_iso_code: 'na',
    language: 'Nauruan',
  },
  {
    name: 'Nepal',
    dial_code: '+977',
    code: 'NP',
    lang_iso_code: 'ne',
    language: 'Nepali',
  },

  {
    name: 'Netherlands',
    dial_code: '+31',
    code: 'NL',
    lang_iso_code: 'nl',
    language: 'Dutch',
  },
  {
    name: 'Netherlands Antilles',
    dial_code: '+599',
    code: 'AN',
    lang_iso_code: 'nl',
    language: 'Dutch',
  },
  {
    name: 'New Caledonia',
    dial_code: '+687',
    code: 'NC',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'New Zealand',
    dial_code: '+64',
    code: 'NZ',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Nicaragua',
    dial_code: '+505',
    code: 'NI',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: 'Niger',
    dial_code: '+227',
    code: 'NE',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Nigeria',
    dial_code: '+234',
    code: 'NG',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Niue',
    dial_code: '+683',
    code: 'NU',
    lang_iso_code: 'niu',
    language: 'Niuean',
  },
  {
    name: 'Norfolk Island',
    dial_code: '+672',
    code: 'NF',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Northern Mariana Islands',
    dial_code: '+1670',
    code: 'MP',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Norway',
    dial_code: '+47',
    code: 'NO',
    lang_iso_code: 'no',
    language: 'Norwegian',
  },
  {
    name: 'Oman',
    dial_code: '+968',
    code: 'OM',
    lang_iso_code: 'ar',
    language: 'Arabic',
  },
  {
    name: 'Pakistan',
    dial_code: '+92',
    code: 'PK',
    lang_iso_code: 'ur',
    language: 'Urdu',
  },
  {
    name: 'Palau',
    dial_code: '+680',
    code: 'PW',
    lang_iso_code: 'pau',
    language: 'Palauan',
  },
  {
    name: 'Palestinian Territory, Occupied',
    dial_code: '+970',
    code: 'PS',
    lang_iso_code: 'ar',
    language: 'Arabic',
  },
  {
    name: 'Panama',
    dial_code: '+507',
    code: 'PA',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: 'Papua New Guinea',
    dial_code: '+675',
    code: 'PG',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Paraguay',
    dial_code: '+595',
    code: 'PY',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: 'Peru',
    dial_code: '+51',
    code: 'PE',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: 'Philippines',
    dial_code: '+63',
    code: 'PH',
    lang_iso_code: 'tl',
    language: 'Tagalog',
  },
  {
    name: 'Pitcairn',
    dial_code: '+872',
    code: 'PN',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Poland',
    dial_code: '+48',
    code: 'PL',
    lang_iso_code: 'pl',
    language: 'Polish',
  },
  {
    name: 'Portugal',
    dial_code: '+351',
    code: 'PT',
    lang_iso_code: 'pt',
    language: 'Portuguese',
  },
  {
    name: 'Puerto Rico',
    dial_code: '+1939',
    code: 'PR',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: 'Qatar',
    dial_code: '+974',
    code: 'QA',
    lang_iso_code: 'ar',
    language: 'Arabic',
  },
  {
    name: 'Romania',
    dial_code: '+40',
    code: 'RO',
    lang_iso_code: 'ro',
    language: 'Romanian',
  },
  {
    name: 'Russian Federation',
    dial_code: '+7',
    code: 'RU',
    lang_iso_code: 'ru',
    language: 'Russian',
  },
  {
    name: 'Rwanda',
    dial_code: '+250',
    code: 'RW',
    lang_iso_code: 'rw',
    language: 'Kinyarwanda',
  },
  {
    name: 'Reunion',
    dial_code: '+262',
    code: 'RE',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Saint Barthelemy',
    dial_code: '+590',
    code: 'BL',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    dial_code: '+290',
    code: 'SH',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Saint Kitts and Nevis',
    dial_code: '+1869',
    code: 'KN',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Saint Lucia',
    dial_code: '+1758',
    code: 'LC',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Saint Martin',
    dial_code: '+590',
    code: 'MF',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Saint Pierre and Miquelon',
    dial_code: '+508',
    code: 'PM',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    dial_code: '+1784',
    code: 'VC',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Samoa',
    dial_code: '+685',
    code: 'WS',
    lang_iso_code: 'sm',
    language: 'Samoan',
  },
  {
    name: 'San Marino',
    dial_code: '+378',
    code: 'SM',
    lang_iso_code: 'it',
    language: 'Italian',
  },
  {
    name: 'Sao Tome and Principe',
    dial_code: '+239',
    code: 'ST',
    lang_iso_code: 'pt',
    language: 'Portuguese',
  },
  {
    name: 'Saudi Arabia',
    dial_code: '+966',
    code: 'SA',
    lang_iso_code: 'ar',
    language: 'Arabic',
  },
  {
    name: 'Senegal',
    dial_code: '+221',
    code: 'SN',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Serbia',
    dial_code: '+381',
    code: 'RS',
    lang_iso_code: 'sr',
    language: 'Serbian',
  },
  {
    name: 'Seychelles',
    dial_code: '+248',
    code: 'SC',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Sierra Leone',
    dial_code: '+232',
    code: 'SL',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Singapore',
    dial_code: '+65',
    code: 'SG',
    lang_iso_code: 'en',
    language: 'English',
  },

  {
    name: 'Slovakia',
    dial_code: '+421',
    code: 'SK',
    lang_iso_code: 'sk',
    language: 'Slovak',
  },
  {
    name: 'Slovenia',
    dial_code: '+386',
    code: 'SI',
    lang_iso_code: 'sl',
    language: 'Slovene',
  },
  {
    name: 'Solomon Islands',
    dial_code: '+677',
    code: 'SB',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Somalia',
    dial_code: '+252',
    code: 'SO',
    lang_iso_code: 'so',
    language: 'Somali',
  },
  {
    name: 'South Africa',
    dial_code: '+27',
    code: 'ZA',
    lang_iso_code: 'af',
    language: 'Afrikaans',
  },
  {
    name: 'South Sudan',
    dial_code: '+211',
    code: 'SS',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    dial_code: '+500',
    code: 'GS',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Spain',
    dial_code: '+34',
    code: 'ES',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: 'Sri Lanka',
    dial_code: '+94',
    code: 'LK',
    lang_iso_code: 'si',
    language: 'Sinhala',
  },
  {
    name: 'Sudan',
    dial_code: '+249',
    code: 'SD',
    lang_iso_code: 'ar',
    language: 'Arabic',
  },
  {
    name: 'Suriname',
    dial_code: '+597',
    code: 'SR',
    lang_iso_code: 'nl',
    language: 'Dutch',
  },
  {
    name: 'Svalbard and Jan Mayen',
    dial_code: '+47',
    code: 'SJ',
    lang_iso_code: 'no',
    language: 'Norwegian',
  },
  {
    name: 'Swaziland',
    dial_code: '+268',
    code: 'SZ',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Sweden',
    dial_code: '+46',
    code: 'SE',
    lang_iso_code: 'sv',
    language: 'Swedish',
  },
  {
    name: 'Switzerland',
    dial_code: '+41',
    code: 'CH',
    lang_iso_code: 'de',
    language: 'German',
  },
  {
    name: 'Syrian Arab Republic',
    dial_code: '+963',
    code: 'SY',
    lang_iso_code: 'ar',
    language: 'Arabic',
  },
  {
    name: 'Taiwan',
    dial_code: '+886',
    code: 'TW',
    lang_iso_code: 'zh',
    language: 'Chinese',
  },
  {
    name: 'Tajikistan',
    dial_code: '+992',
    code: 'TJ',
    lang_iso_code: 'tg',
    language: 'Tajik',
  },
  {
    name: 'Tanzania, United Republic of Tanzania',
    dial_code: '+255',
    code: 'TZ',
    lang_iso_code: 'sw',
    language: 'Swahili',
  },
  {
    name: 'Thailand',
    dial_code: '+66',
    code: 'TH',
    lang_iso_code: 'th',
    language: 'Thai',
  },
  {
    name: 'Timor-Leste',
    dial_code: '+670',
    code: 'TL',
    lang_iso_code: 'pt',
    language: 'Portuguese',
  },
  {
    name: 'Togo',
    dial_code: '+228',
    code: 'TG',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Tokelau',
    dial_code: '+690',
    code: 'TK',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Tonga',
    dial_code: '+676',
    code: 'TO',
    lang_iso_code: 'to',
    language: 'Tongan',
  },
  {
    name: 'Trinidad and Tobago',
    dial_code: '+1868',
    code: 'TT',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Tunisia',
    dial_code: '+216',
    code: 'TN',
    lang_iso_code: 'ar',
    language: 'Arabic',
  },
  {
    name: 'Turkey',
    dial_code: '+90',
    code: 'TR',
    lang_iso_code: 'tr',
    language: 'Turkish',
  },
  {
    name: 'Turkmenistan',
    dial_code: '+993',
    code: 'TM',
    lang_iso_code: 'tk',
    language: 'Turkmen',
  },
  {
    name: 'Turks and Caicos Islands',
    dial_code: '+1649',
    code: 'TC',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Tuvalu',
    dial_code: '+688',
    code: 'TV',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Uganda',
    dial_code: '+256',
    code: 'UG',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Ukraine',
    dial_code: '+380',
    code: 'UA',
    lang_iso_code: 'uk',
    language: 'Ukrainian',
  },
  {
    name: 'United Arab Emirates',
    dial_code: '+971',
    code: 'AE',
    lang_iso_code: 'ar',
    language: 'Arabic',
  },
  {
    name: 'United Kingdom',
    dial_code: '+44',
    code: 'GB',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'United States',
    dial_code: '+1',
    code: 'US',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Uruguay',
    dial_code: '+598',
    code: 'UY',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: 'Uzbekistan',
    dial_code: '+998',
    code: 'UZ',
    lang_iso_code: 'uz',
    language: 'Uzbek',
  },
  {
    name: 'Vanuatu',
    dial_code: '+678',
    code: 'VU',
    lang_iso_code: 'bi',
    language: 'Bislama',
  },
  {
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    dial_code: '+58',
    code: 'VE',
    lang_iso_code: 'es',
    language: 'Spanish',
  },
  {
    name: 'Vietnam',
    dial_code: '+84',
    code: 'VN',
    lang_iso_code: 'vi',
    language: 'Vietnamese',
  },
  {
    name: 'Virgin Islands, British',
    dial_code: '+1284',
    code: 'VG',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Virgin Islands, U.S.',
    dial_code: '+1340',
    code: 'VI',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Wallis and Futuna',
    dial_code: '+681',
    code: 'WF',
    lang_iso_code: 'fr',
    language: 'French',
  },
  {
    name: 'Yemen',
    dial_code: '+967',
    code: 'YE',
    lang_iso_code: 'ar',
    language: 'Arabic',
  },
  {
    name: 'Zambia',
    dial_code: '+260',
    code: 'ZM',
    lang_iso_code: 'en',
    language: 'English',
  },
  {
    name: 'Zimbabwe',
    dial_code: '+263',
    code: 'ZW',
    lang_iso_code: 'en',
    language: 'English',
  },
];
